"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _barrier, _queue, _interval, _running;
Object.defineProperty(exports, "__esModule", { value: true });
class PromisedCall {
    constructor(resolve, reject, fn) {
        this.resolve = resolve;
        this.reject = reject;
        this.fn = fn;
    }
}
/** @ignore */
class AsyncCallQueue {
    constructor(barrier) {
        _barrier.set(this, null);
        _queue.set(this, new Array());
        _interval.set(this, void 0);
        _running.set(this, false);
        __classPrivateFieldSet(this, _barrier, barrier);
    }
    start() {
        __classPrivateFieldSet(this, _interval, setInterval(this.run.bind(this), 100));
    }
    stop() {
        if (__classPrivateFieldGet(this, _interval)) {
            clearInterval(__classPrivateFieldGet(this, _interval));
        }
    }
    run() {
        if (__classPrivateFieldGet(this, _queue).length > 0 && __classPrivateFieldGet(this, _barrier).call(this) && !__classPrivateFieldGet(this, _running)) {
            __classPrivateFieldSet(this, _running, true);
            const promiseCall = __classPrivateFieldGet(this, _queue).shift();
            promiseCall
                .fn()
                .then((r) => {
                promiseCall.resolve(r);
                __classPrivateFieldSet(this, _running, false);
            })
                .catch((e) => {
                promiseCall.reject(e);
                __classPrivateFieldSet(this, _running, false);
            });
        }
    }
    push(object, fn, ...args) {
        return new Promise((resolve, reject) => {
            const p = new PromisedCall(resolve, reject, fn.bind(object, ...args));
            __classPrivateFieldGet(this, _queue).push(p);
        });
    }
}
_barrier = new WeakMap(), _queue = new WeakMap(), _interval = new WeakMap(), _running = new WeakMap();
exports.default = AsyncCallQueue;
